import type {
  HubAlgorithmDefinition,
  HubBlobArtifact,
} from '@robovision/hub'
import {
  JobBaseArtifact,
  type JobBaseArtifactParams,
} from './JobBaseArtifact'


export interface JobBlobArtifactParams extends JobBaseArtifactParams {
  mimeType?: string
}

export class JobBlobArtifact extends JobBaseArtifact {
  public mimeType?: string

  protected constructor (params: JobBlobArtifactParams) {
    super(params)
    this.mimeType = params.mimeType
  }

  public static fromDefinition (
    blobArtifact: HubBlobArtifact,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const blobDef = algorithmDefinition.blobDefinitions?.find(
      (def) => def.id === blobArtifact.blobDefinition,
    )

    if (!blobDef) {
      throw new Error(
        `Invalid schema. Blob definition ${blobArtifact.blobDefinition} not found`,
      )
    }

    return new JobBlobArtifact({
      artifactId: blobArtifact.id,
      definitionId: blobDef.id,
      description: blobArtifact.description,
      mimeType: blobDef.mimetype,
      name: blobArtifact.name,
    })
  }
}
